import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { AppState } from "../store";

const initialState = {
  messages: [] as string[],
};

const slice = createSlice({
  name: "error",
  initialState,
  reducers: {
    addMsg: (state, action: PayloadAction<string>) => {
      state.messages.push(action.payload);
    },
  },
});

export const selectErrorMessages = (state: AppState) => {
  if (!state.error) return null;
  return state.error.messages;
};

export default slice.reducer;
